import get from 'lodash/get';
import { call } from 'redux-saga/effects';

export const serviceSheetBlocksWorkComplete = (booking) => {
  const readiness = get(booking, 'workCompleteReadiness');
  return Boolean(readiness && readiness.serviceSheetRequired && !readiness.serviceSheetSubmitted);
};

export const workCompleteErrorMessage = (error) =>
  get(error, 'response.data.message') || 'Could not mark work complete';

export const submitMarkWorkComplete = async ({ booking, patch, notifyError, reloadBooking }) => {
  const garage = booking.garageInvites?.find((invite) => invite.status === 'accepted')?.garage;

  if (!garage?.xeroId) {
    notifyError(`Please add a Xero ID to ${garage?.businessName || 'this garage'}`);
    return;
  }

  try {
    await patch();
    setTimeout(reloadBooking, 2500);
  } catch (error) {
    notifyError(workCompleteErrorMessage(error));
  }
};

const workCompleteIsNext = (booking) => {
  const nextStatuses = get(booking, 'masterStatus.nextMasterStatusList', []);
  return nextStatuses.some((status) => status.masterStatusName === 'WORK_COMPLETE');
};

export function* loadWorkCompleteReadiness(booking, request) {
  if (!workCompleteIsNext(booking)) return booking;

  try {
    const readiness = yield call(request, `bookings/${booking.bookingId}/work-complete-readiness`);
    return { ...booking, workCompleteReadiness: readiness.data };
  } catch (error) {
    console.error('Failed to load work-complete readiness', error);
    return booking;
  }
}

export const mergeWorkCompleteReadiness = (previousBooking, nextBooking) => {
  if (!nextBooking || nextBooking.workCompleteReadiness) return nextBooking;
  if (!previousBooking) return nextBooking;

  const previous = previousBooking.toJS ? previousBooking.toJS() : previousBooking;
  if (previous.bookingId !== nextBooking.bookingId || !previous.workCompleteReadiness) return nextBooking;
  if (!workCompleteIsNext(nextBooking)) return nextBooking;

  return { ...nextBooking, workCompleteReadiness: previous.workCompleteReadiness };
};
